import React, { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import ResourceList from './ResourceList';

const AdditionalResources = (props) => {
  const { selectedSeries } = props;
  const [resources, setResources] = useState(false);
  const [isLoadingResources, setIsLoadingResources] = useState(false);

  const getSeriesTitle = (series) => {
    if (!series) return null;
    if (Array.isArray(series)) return series[0];
    return series;
  }

  const fetchResources = () => {
    const seriesTitle = getSeriesTitle(selectedSeries);
    if (!seriesTitle) return;
    setIsLoadingResources(true);
    let apiPath = `/component-selector/v1/resources?&series_title=` + encodeURIComponent(seriesTitle);
    let timestamp = new Date().getTime();
    apiPath += `&t=${timestamp}`;
    apiFetch({ path: apiPath }).then(response => {
      setResources(response);
      //console.log(response);
      setIsLoadingResources(false);
    }).catch(error => {
        console.error('Error fetching data:', error);
        setIsLoadingResources(false);
    });
  }


  //fetch resources when component loads or selectedSeries changes
  useEffect(() => {
    const seriesTitle = getSeriesTitle(selectedSeries);
    if(!seriesTitle) return;
    fetchResources();

  }, [selectedSeries]);

  return (
    <div className={`table-only`}>
         {isLoadingResources 
            ?  <div>Loading...</div>
            : (resources && resources?.categories) 
                ?  <div className={`component-resources`}>
                  <h3 className="wp-block-heading">Additional resources</h3>
                  <ResourceList categories={resources.categories} />
                </div>
              : <div></div>
          }
    </div>
  );
};

export default AdditionalResources;
